import { useState } from "react";
import analog from "../../assets/images/analog.svg";
import settings from "../../assets/images/settings.svg";
import {
  Button,
  ConnectWalletModal,
  ConnectedWalletDropdown,
} from "../../components/UI";
import { useWallet } from "../../hooks/useWallet";
import { showCustomToast } from "../../components/UI/Toast/Toast";
import { useWallet as useWalletConnect } from "@/contexts";

const Header = () => {
  const [isConnectWalletModalOpen, setIsConnectWalletModalOpen] =
    useState(false);
  const { wallet, disconnectWallet } = useWallet();
  const { setSelectedAccount } = useWalletConnect();

  const handleDisconnect = async () => {
    try {
      await disconnectWallet(setSelectedAccount);
      showCustomToast("success", "Wallet Disconnected Successfully!");
    } catch (error) {
      console.error("Failed to disconnect wallet:", error);
      showCustomToast(
        "error",
        "Failed to disconnect wallet. Please try again."
      );
    }
  };

  return (
    <>
      <nav className=" dark:bg-gray-900 backdrop-blur-6xl fixed w-full z-20 top-0 start-0 border-b  border-borderGlass">
        <div className=" flex flex-wrap bg-bgGlass items-center justify-between mx-auto py-4 px-12">
          <a
            href="https://flowbite.com/"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={analog} className="h-8" alt="analog-logo" />
          </a>
          <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
            {wallet ? (
              <ConnectedWalletDropdown
                walletInfo={wallet}
                onDisconnect={handleDisconnect}
              />
            ) : (
              <Button
                variant="outline"
                onClick={() => setIsConnectWalletModalOpen(true)}
              >
                Connect Wallet
              </Button>
            )}
            <button
              data-collapse-toggle="navbar-sticky"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-sticky"
              aria-expanded="false"
            >
              <span className="sr-only">Connect Wallet</span>
              <img src={settings} alt="setting-logo" />
            </button>
          </div>
        </div>
      </nav>

      <ConnectWalletModal
        isOpen={isConnectWalletModalOpen}
        onClose={() => setIsConnectWalletModalOpen(false)}
      />
    </>
  );
};

export default Header;
